import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d9cdd5dc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d9cdd5dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cdd5dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9cdd5dc')) {
      api.createRecord('d9cdd5dc', component.options)
    } else {
      api.reload('d9cdd5dc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d9cdd5dc&scoped=true&", function () {
      api.rerender('d9cdd5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2btxGZi0FcoWy/JS/comp/DocBox.vue"
export default component.exports